import type { RootState } from 'state';
import { AirportsFrom } from '../constants/filtersKeys';

function isFetchingAirportsFromInProgress(state: RootState): boolean {
  const { fetching } = state.flightCalendars.filtersOptions;
  return fetching.indexOf(AirportsFrom) !== -1;
}

export default isFetchingAirportsFromInProgress;
